import {Directive, Input, OnInit, TemplateRef} from '@angular/core';
import { DynamicListingService } from '../services/dynamic-listing.service';;

@Directive({
  selector: '[frameworkListingTemplate]',
})
export class ListingTemplateDirective implements OnInit{
  @Input() frameworkListingTemplate: any;
  constructor(
    protected dynamicListingService: DynamicListingService,
    protected templateRef: TemplateRef<any>,
  ) {}

  ngOnInit(): void {
    this.dynamicListingService.addTemplate(this.frameworkListingTemplate, this.templateRef);
  }
}
